import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTES } from './config';
import {
  ArchivedResponse,
  CaseDetails,
  ConsultationResponse,
  ConsultationSummary,
  CreateOrganisation,
  EditOrganisation,
  Home,
  ManageAdminUsers,
  ManageConsultees,
  Measure,
  Monitor,
  PageNotFound,
  Report,
  Reports,
  Search,
  UnAuthorised,
} from './pages';
import { ManageTeam } from './pages/ManageTeam';

export const App: React.FC = () => {
  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<Home />} />
      <Route path={ROUTES.SEARCH} element={<Search />} />
      <Route path={ROUTES.REPORTS} element={<Reports />} />
      <Route path={ROUTES.REPORT} element={<Report />} />
      <Route path={ROUTES.CONSULTATION} element={<ConsultationSummary />} />
      <Route path={ROUTES.DETAILS} element={<CaseDetails />} />
      <Route path={ROUTES.RESPONSE} element={<ConsultationResponse />} />
      <Route path={ROUTES.ARCHIVEDRESPONSE} element={<ArchivedResponse />} />
      <Route path={ROUTES.MEASURE} element={<Measure />} />
      <Route path={ROUTES.MONITOR} element={<Monitor />} />
      <Route path={ROUTES.MANAGETEAM} element={<ManageTeam />} />
      <Route path={ROUTES.MANAGEADMINUSERS} element={<ManageAdminUsers />} />
      <Route path={ROUTES.MANAGECONSULTEES} element={<ManageConsultees />} />
      <Route path={ROUTES.CREATEORGANISATION} element={<CreateOrganisation />} />
      <Route path={ROUTES.EDITORGANISATION} element={<EditOrganisation />} />
      <Route path={ROUTES.EDITORGANISATIONPATH} element={<EditOrganisation />} />
      <Route path={ROUTES.UNAUTHORISED} element={<UnAuthorised />} />
      <Route path='*' element={<PageNotFound />} />
    </Routes>
  );
};
